const styles = {
  container: '',

  list: 'grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 xl:grid-cols-8 gap-3 sm:gap-4',

  // viewer: {
  //   container: 'fixed left-0 top-0 right-0 bottom-0 z-50 bg-teal-rgba',
  //   content: '',
  //   navigation: {
  //     container: 'w-full h-screen p-4 sm:p-8 h-screen fixed',

  //     head: 'w-full flex flex-row items-center justify-between',
  //     body: 'w-full h-full flex flex-row items-center justify-between',

  //     content: 'font-sans text-white text-sm',
  //     alt: 'font-semibold',
  //     date: 'font-light',
  //   },

  //   button:
  //     'aspect-square w-12 bg-gray-200 text-gray-800 rounded-full flex items-center justify-center',
  // },
};

export default styles;
